import { z } from "zod";

export const HistoryOriginValues = [
  "AUTONOMOUS",
  "BACKFILL",
  "CONTRACTOR_MOBILE_APP",
  "EDEN",
  "HOMEOWNER_PORTAL_APP",
  "INITIAL_UNKNOWN",
  "INNGEST",
  "INTERNAL_API",
  "JOB_SCHEDULER",
  "PARTNER_API",
  "REMI_APP",
  "REMI_MCP",
  "SCRIPT",
  "SIDE_EFFECT",
  "SQS_QUEUE",
  "TEST",
  "UPSTASH_QUEUE",
  "WEBHOOK_LAMBDA",
  "WEBHOOK_NEXT",
] as const;

export const HistoryOriginSchema = z.enum(HistoryOriginValues);
export const HistoryOrigin = HistoryOriginSchema.enum;
export type HistoryOrigin = (typeof HistoryOriginValues)[number];

export const HistoryOriginDisplayNames = {
  AUTONOMOUS: "Autonomous agent",
  BACKFILL: "Backfill",
  CONTRACTOR_MOBILE_APP: "Contractor mobile app",
  EDEN: "Eden",
  HOMEOWNER_PORTAL_APP: "Homeowner portal app",
  INITIAL_UNKNOWN: "Initial (unknown)",
  INNGEST: "Inngest",
  INTERNAL_API: "Internal API (oddjob)",
  JOB_SCHEDULER: "Job scheduler",
  PARTNER_API: "Partner API",
  REMI_APP: "Remi app",
  REMI_MCP: "Remi MCP",
  SCRIPT: "Script",
  SIDE_EFFECT: "Side effect",
  SQS_QUEUE: "SQS queue",
  TEST: "Test",
  UPSTASH_QUEUE: "Upstash queue",
  WEBHOOK_LAMBDA: "Webhook Lambda",
  WEBHOOK_NEXT: "Webhook (Next.js)",
} satisfies Record<HistoryOrigin, string>;

export const createGuardedHistoryOriginSchema = (onUnknown?: (rawOrigin: unknown) => void) =>
  HistoryOriginSchema.catch((ctx) => {
    onUnknown?.(ctx.value);
    return HistoryOrigin.INITIAL_UNKNOWN;
  });

export const GuardedHistoryOriginSchema = createGuardedHistoryOriginSchema();
